import { useState } from "react";
import { groupApi } from "../api/group.service";
import { ActionMultiAttendantPayload } from "../types";

export const useActionMultiAttendant = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (
    group_id: string,
    payload: ActionMultiAttendantPayload
  ) => {
    try {
      setLoading(true);

      const response: any = await groupApi.actionMultiMember(group_id, payload);

      return {
        success: true,
        message: response?.data?.message,
        success_count: response?.data?.data?.success_count,
        error_count: response?.data?.data?.error_count,
        error: response?.data?.data?.errors || null,
      };
    } catch (err: any) {
      console.log("Action multi attendant failed:", err);

      return {
        success: false,
        message: err?.message || "Something wrong",
        success_count: 0,
        error_count:
          err?.response?.data?.error?.serializer?.errors?.length || 0,
        error: err?.response?.data?.error?.serializer?.errors,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
